import { render, staticRenderFns } from "./uploadLink.vue?vue&type=template&id=631bef0a&scoped=true&"
import script from "./uploadLink.vue?vue&type=script&lang=js&"
export * from "./uploadLink.vue?vue&type=script&lang=js&"
import style0 from "./uploadLink.vue?vue&type=style&index=0&id=631bef0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631bef0a",
  null
  
)

export default component.exports